// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * CSS custom properties for TwentyTwentysix redesign.
 * Scoped or imported only within twentytwentysix context to avoid affecting current site.
 */
:root {
  /* Colors */
  --twentytwentysix-color-primary: #53BAB4;
  --twentytwentysix-color-primary-dark: #3d9a95;
  --twentytwentysix-color-accent: #F69B42;
  --twentytwentysix-color-text: #333333;
  --twentytwentysix-color-text-muted: #707070;
  --twentytwentysix-color-background: #ffffff;
  --twentytwentysix-color-background-alt: #f8f8f8;
  --twentytwentysix-color-border: #e0e0e0;

  /* Typography */
  --twentytwentysix-font-family: 'Nunito Sans', -apple-system, BlinkMacSystemFont, sans-serif;
  --twentytwentysix-font-heading: 'Oswald', 'Nunito Sans', sans-serif;
  --twentytwentysix-font-size-xs: 12px;
  --twentytwentysix-font-size-sm: 14px;
  --twentytwentysix-font-size-base: 16px;
  --twentytwentysix-font-size-lg: 18px;
  --twentytwentysix-font-size-xl: 24px;
  --twentytwentysix-font-size-2xl: 32px;
  --twentytwentysix-font-size-3xl: 40px;

  /* Spacing */
  --twentytwentysix-spacing-xs: 4px;
  --twentytwentysix-spacing-sm: 8px;
  --twentytwentysix-spacing-md: 16px;
  --twentytwentysix-spacing-lg: 24px;
  --twentytwentysix-spacing-xl: 32px;
  --twentytwentysix-spacing-xxl: 48px;
  --twentytwentysix-spacing-section: 64px;
  --twentytwentysix-spacing-section-lg: 96px;

  /* Radius */
  --twentytwentysix-radius-sm: 4px;
  --twentytwentysix-radius-md: 8px;
  --twentytwentysix-radius-lg: 12px;

  /* Container */
  --twentytwentysix-container-max: 1280px;
  --twentytwentysix-container-narrow: 720px;
}
`, "",{"version":3,"sources":["webpack://./src/components/twentytwentysix/styles/tokens.css"],"names":[],"mappings":"AAAA;;;EAGE;AACF;EACE,WAAW;EACX,wCAAwC;EACxC,6CAA6C;EAC7C,uCAAuC;EACvC,qCAAqC;EACrC,2CAA2C;EAC3C,2CAA2C;EAC3C,+CAA+C;EAC/C,uCAAuC;;EAEvC,eAAe;EACf,2FAA2F;EAC3F,mEAAmE;EACnE,oCAAoC;EACpC,oCAAoC;EACpC,sCAAsC;EACtC,oCAAoC;EACpC,oCAAoC;EACpC,qCAAqC;EACrC,qCAAqC;;EAErC,YAAY;EACZ,iCAAiC;EACjC,iCAAiC;EACjC,kCAAkC;EAClC,kCAAkC;EAClC,kCAAkC;EAClC,mCAAmC;EACnC,uCAAuC;EACvC,0CAA0C;;EAE1C,WAAW;EACX,gCAAgC;EAChC,gCAAgC;EAChC,iCAAiC;;EAEjC,cAAc;EACd,uCAAuC;EACvC,yCAAyC;AAC3C","sourcesContent":["/**\n * CSS custom properties for TwentyTwentysix redesign.\n * Scoped or imported only within twentytwentysix context to avoid affecting current site.\n */\n:root {\n  /* Colors */\n  --twentytwentysix-color-primary: #53BAB4;\n  --twentytwentysix-color-primary-dark: #3d9a95;\n  --twentytwentysix-color-accent: #F69B42;\n  --twentytwentysix-color-text: #333333;\n  --twentytwentysix-color-text-muted: #707070;\n  --twentytwentysix-color-background: #ffffff;\n  --twentytwentysix-color-background-alt: #f8f8f8;\n  --twentytwentysix-color-border: #e0e0e0;\n\n  /* Typography */\n  --twentytwentysix-font-family: 'Nunito Sans', -apple-system, BlinkMacSystemFont, sans-serif;\n  --twentytwentysix-font-heading: 'Oswald', 'Nunito Sans', sans-serif;\n  --twentytwentysix-font-size-xs: 12px;\n  --twentytwentysix-font-size-sm: 14px;\n  --twentytwentysix-font-size-base: 16px;\n  --twentytwentysix-font-size-lg: 18px;\n  --twentytwentysix-font-size-xl: 24px;\n  --twentytwentysix-font-size-2xl: 32px;\n  --twentytwentysix-font-size-3xl: 40px;\n\n  /* Spacing */\n  --twentytwentysix-spacing-xs: 4px;\n  --twentytwentysix-spacing-sm: 8px;\n  --twentytwentysix-spacing-md: 16px;\n  --twentytwentysix-spacing-lg: 24px;\n  --twentytwentysix-spacing-xl: 32px;\n  --twentytwentysix-spacing-xxl: 48px;\n  --twentytwentysix-spacing-section: 64px;\n  --twentytwentysix-spacing-section-lg: 96px;\n\n  /* Radius */\n  --twentytwentysix-radius-sm: 4px;\n  --twentytwentysix-radius-md: 8px;\n  --twentytwentysix-radius-lg: 12px;\n\n  /* Container */\n  --twentytwentysix-container-max: 1280px;\n  --twentytwentysix-container-narrow: 720px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
